<template>
  <dialog-modal-fi
    ref="dialogModal"
    class="consent-dialog-fi"
    only-body-scrollable
    prevent-close-on-click-outside
    pulse-on-block
    hide-close-button
  >
    <template #header>
      <h2 class="consent-dialog-fi__headline">
        {{ fields.consentDialogHeadline?.value }}
      </h2>
    </template>

    <template #body>
      <div class="consent-dialog-fi__content">
        <div
          v-if="fields.consentDialogInfotext?.value"
          class="consent-dialog-fi__content__info"
        >
          {{ fields.consentDialogInfotext.value }}
        </div>

        <div
          v-if="
            fields.consentDialogTermsAndConditionsTitle?.value &&
            fields.consentDialogTermsAndConditionsText?.value
          "
          class="consent-dialog-fi__content__item"
        >
          <h3 class="consent-dialog-fi__content__title">
            {{ fields.consentDialogTermsAndConditionsTitle.value }}
          </h3>

          <richtext-fi
            class="consent-dialog-fi__content__text"
            :html-content="fields.consentDialogTermsAndConditionsText"
          />

          <link-fi
            v-if="
              fields.consentDialogTermsAndConditionsLink?.value &&
              (fields.consentDialogTermsAndConditionsLink.value.url ||
                fields.consentDialogTermsAndConditionsLink.value.href)
            "
            class="consent-dialog-fi__content__link"
            :href="
              fields.consentDialogTermsAndConditionsLink.value.url ||
              fields.consentDialogTermsAndConditionsLink.value.href
            "
            :external="Boolean(fields.consentDialogTermsAndConditionsLink.value.url)"
            primary
            target="_blank"
          >
            {{ fields.consentDialogTermsAndConditionsLink.value.text }}
          </link-fi>
        </div>
        <div
          v-if="
            fields.consentDialogTermsOfUseTitle?.value && fields.consentDialogTermsOfUseText?.value
          "
          class="consent-dialog-fi__content__item"
        >
          <h3 class="consent-dialog-fi__content__title">
            {{ fields.consentDialogTermsOfUseTitle.value }}
          </h3>

          <richtext-fi
            class="consent-dialog-fi__content__text"
            :html-content="fields.consentDialogTermsOfUseText"
          />

          <link-fi
            v-if="
              fields.consentDialogTermsOfUseLink?.value &&
              (fields.consentDialogTermsOfUseLink.value.url ||
                fields.consentDialogTermsOfUseLink.value.href)
            "
            class="consent-dialog-fi__content__link"
            :href="
              fields.consentDialogTermsOfUseLink.value.url ||
              fields.consentDialogTermsOfUseLink.value.href
            "
            :external="Boolean(fields.consentDialogTermsOfUseLink.value.url)"
            target="_blank"
            primary
          >
            {{ fields.consentDialogTermsOfUseLink.value.text }}
          </link-fi>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="consent-dialog-fi__actions">
        <button-fi
          :class="{
            'consent-dialog-fi__button button-fi__primary': true,
            'button-fi--large': isSM,
          }"
          type="button"
          @click.prevent="confirm"
        >
          {{ fields.consentDialogButton?.value }}
        </button-fi>
      </div>
    </template>

    <template #button>
      <icon-fi icon="close" />
    </template>
  </dialog-modal-fi>
</template>

<script>
import { ButtonFi, DialogModalFi, IconFi, LinkFi, RichtextFi } from 'atoms';
import breakpointMixin from 'mixins/breakpointMixin';

export default {
  name: 'ConsentDialogFi',
  components: {
    ButtonFi,
    IconFi,
    DialogModalFi,
    LinkFi,
    RichtextFi,
  },
  mixins: [breakpointMixin],
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['confirm'],
  methods: {
    open() {
      this.$refs.dialogModal.open();
    },
    close() {
      this.$refs.dialogModal.close();
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="scss">
@import './consent-dialog-fi';
</style>
